import React from 'react';

import { noop } from 'ui-components/default-props/noop';

import { SuggestAlternativeRatePopover } from './suggest-alternative-rate-popover';
import { Multiple } from '../../../components/multiple-text-blurb-for-grid';

/**
 * @typedef SavingsObject
 * @type {object}
 * @param {number} props.savings.value - The value of the savings.
 * @param {string} props.savings.code - The currency code of the savings.
 */

/**
 * @param {object} props
 * @param {string} props.orderNumberStyle
 * @param {boolean} props.showAlternativeRate
 * @param {string} props.alternateServiceName
 * @param {SavingsObject} props.savings
 * @param {() => void} props.saveConfiguration
 * @param {() => void} props.onPopOverOpen - The function to run when icon clicked.
 * @param {React.ReactNode} props.fraudIcon - Fraud indicator icon with tooltip. Rendered when Loss Prevention feature is enabled and the order has fraud detection indicators. Null otherwise.
 * @returns {JSX.Element}
 */
export const MultipleOrderNumberWithAlternativeRate = ({
  orderNumberStyle = undefined,
  showAlternativeRate = false,
  alternateServiceName = undefined,
  savings = undefined,
  saveConfiguration = noop,
  onPopOverOpen = noop,
  fraudIcon = null,
}) => {
  return (
    <div className={orderNumberStyle}>
      <Multiple />
      {showAlternativeRate ? (
        <SuggestAlternativeRatePopover
          alternateServiceName={alternateServiceName}
          onPopOverOpen={onPopOverOpen}
          saveConfiguration={saveConfiguration}
          savings={savings}
        />
      ) : null}
      {fraudIcon}
    </div>
  );
};
